import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import {
  usePatchAccountViaCSVMutation,
  useSysAccountCreateAccountsMutation,
  } from "@/api/hooks/sys-account-hooks";
import BulkOperationReportModal from "@/components/bulk-operation-report-modal";
import { ResultDtoSysAccountRegularDto } from "@/shared/api";
import { Button, CircularProgress } from "@mui/material";
import { SendTimeExtension } from "@mui/icons-material";
import { enqueueSnackbar } from "notistack";
import PatchingAccountsModal from "@/components/config-modals/patching-accounts-modal";

const PatchAccountsTableControl = ({
  roomName,
  onSuccess,
}: {
  roomName: string;
  onSuccess?: (data: ResultDtoSysAccountRegularDto[]) => void;
}) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const [operationResult, setOperationResult] = useState<ResultDtoSysAccountRegularDto[]>();

  const {mutate: patchAccountsViaCsvMutate, isPending: patchAccountsViaCsvMutateIsPending} =
    usePatchAccountViaCSVMutation()

  function handlePatchAccounts(csvFile: File) {
    patchAccountsViaCsvMutate({
      domain: roomName,
      file: csvFile
    }, {
      onSuccess: (response) => {
        setIsOpen(false);
        setOperationResult(response.data);
        onSuccess && onSuccess(response.data);
      },
      onError: (error) => {
        enqueueSnackbar(t("importAccountsTableControl.errorWhileCreatingElements"), {variant: "error"});
        console.error("Something went wrong while creating elements", error);
      },
    })
  }

  return (
    <>
      <Button onClick={() => setIsOpen(true)}>
        <SendTimeExtension /> {t("patchCsv")}
      </Button>
      {isOpen && (
        <PatchingAccountsModal
          title={t("Patch accounts")}
          isOnSaveResponsePending={patchAccountsViaCsvMutateIsPending}
          onSave={(csvFile) => handlePatchAccounts(csvFile)}
          onCancel={() => setIsOpen(false)}
        />
      )}

      {operationResult != null && (
        <BulkOperationReportModal
          open
          showProblematic
          showSuccess
          title={t("importAccountsTableControl.operationResultTitle")}
          resultList={operationResult}
          onCancel={() => setOperationResult(undefined)}
        />
      )}
    </>
  );
};

export default PatchAccountsTableControl;
